<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2"><em>Dedicated<br/> with many thanks to Jim and Jen<br/> for their unwitting suggestion of a wonderful plot device<br/> and for our amazing Cameron
            Scott,<br/> born 6 October 2008</em></p>
<p class="pb"> </p>
<p class="img" id="ch1"><img alt="art" src="images/Art_Pmap.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SeducedByARogu_dedi-1.vue?2f593106